import { reportUserReadMsgOffset } from '@/services/chat';
import { debounce } from '@/utils/lodashReplacement';
import { ReportAgentMessageTimeout } from '@/utils/constants';
import initStore from '@/stores/init';
import JSBI from 'jsbi';

let lastReportAgentMessageId = '';

export const reportAgentMessage = (lastestAgentMessageId: string) => {
  const numberRegx = /^\d+$/;

  // 全都是数字 && 需要上报的比上一次上报的大
  if (
    numberRegx.test(lastestAgentMessageId)
    && JSBI.greaterThan(JSBI.BigInt(lastestAgentMessageId), JSBI.BigInt(lastReportAgentMessageId))
  ) {
    lastReportAgentMessageId = lastestAgentMessageId;

    if (initStore.isPageActive) {
      debounceReportAgentMessage();
    }
  }
};

export const debounceReportAgentMessage = debounce(() => {
  if (lastReportAgentMessageId) {
    reportUserReadMsgOffset({ latest_agent_chat_message_id: lastReportAgentMessageId })
      .catch(() => {});
  }
}, ReportAgentMessageTimeout);
